<nz-alert
  class="mb-md"
  nzType="warning"
  nzMessage="'聚合对象'暂时无法查看成绩详情数据, 无法进行阅卷和错题重练操作"
></nz-alert>
@for (detail of taskAnalysisSrv.taskPackDetails; track detail) {
  <nz-card class="point mb-[12px]" (click)="changeTask(detail)" [nzBodyStyle]="{ padding: '16px' }">
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <div class="classroomname">
          <!-- taskId 为 number | string（聚合数据行取字符串 'all'/'my'） -->
          @if (['all', 'my'].includes(detail.taskId)) {
            <span class="tag">聚合数据</span>
          }
          {{ detail.classroomName }}
        </div>
        <div class="mt-sm">任务人数: {{ detail.studentCount }}</div>
      </div>
      <div nz-col>
        <g2-ring-progress
          [options]="{
            width: 60,
            height: 60,
            innerRadius: 0.9,
            statistic: { content: { style: { fontSize: '10px' } } },
            autoFit: true,
            percent: detail.correctPercent / 100,
            color: getEnvaluateColor(detail.correctPercent),
          }"
        ></g2-ring-progress>
      </div>
    </div>
  </nz-card>
}
